const base = (process.env.VITE_API_URL || process.env.VITE_NODE_API_URL || 'http://localhost:3000').replace(/\/+$/, '');
const storageKey = 'hrp.prejoining.invitation';
let currentToken;

export function takeInvitationToken() {
    const fragment = new URLSearchParams(window.location.hash.slice(1)).get('token');
    if (fragment) {
        window.history.replaceState(null, '', window.location.pathname);
        currentToken = fragment;
        try { window.sessionStorage.setItem(storageKey, fragment); } catch { /* In-memory access still works. */ }
    } else if (!currentToken) {
        try { currentToken = window.sessionStorage.getItem(storageKey); } catch { /* Restricted browser storage. */ }
    }
    return currentToken;
}
export function clearInvitationToken() {
    currentToken = null;
    try { window.sessionStorage.removeItem(storageKey); } catch { /* Restricted browser storage. */ }
}

export async function candidateRequest(token, path = '', { method = 'GET', body } = {}) {
    const multipart = body instanceof FormData;
    let response;
    try {
        response = await fetch(`${base}/api/public/prejoining${path}`, { method, credentials: 'omit', cache: 'no-store',
            referrerPolicy: 'no-referrer', headers: { Authorization: `Prejoining ${token || ''}`,
                ...(!multipart && body ? { 'Content-Type': 'application/json' } : {}) },
            body: body ? (multipart ? body : JSON.stringify(body)) : undefined });
    } catch { throw new Error('Unable to connect. Your changes are still on this page. Please try again.'); }
    let result;
    try { result = await response.json(); } catch { throw new Error('The service is temporarily unavailable. Please try again.'); }
    if (!response.ok) {
        const error = new Error(result.message || 'The form could not be saved. Please try again.');
        error.fields = result.fields || []; error.status = response.status;
        throw error;
    }
    return result.data;
}
